module.exports = __webpack_public_path__ + "static/media/rapipago-logo.228ffefc.svg";